<template>

  <div id="baseFrame" @mousemove="mousemove" @touchmove="mousemove" @mouseup="cancelDrag" @touchend="cancelDrag">
    <div
        v-for="(item, i) in testelements"
        :key="i"
        :id="'line-' + i"
        startId=""
        endId=""
        style="z-index: 99; position:absolute;   width:12px;  border-radius: 20px; margin: 0;   background-color: blue;"
        @click="lineClick"
    ></div>
    <div class="row  no-gutters pt-xl-4 mb-xl-6">
      <div class="col-xl-3 col-6 tab-test-bird order-xl-1 order-2">

      </div>
      <div class="col-xl-6 col-12 tab-test-title order-xl-2 order-1 text-center pt-xl-3 mt-xl-0 mt-4"
           v-if="lesson">
        {{ lesson.lesson }}
      </div>
      <div class="col-xl-3 col-6 tab-video-points test-line order-xl-3 order-3" v-if="points && testmode==0">
        <div class="zerno-points">
          {{ points }}
        </div>
      </div>
      <div class="col-xl-12 col-12 tab-video-notice order-xl-4 order-4 text-center mt-xl-n7 mt-n5 mb-xl-0 mb-3">
        <div class="tab-video-notice-1">{{ $t('test') }} {{ $t('№') }}{{ test.pos }}
          <span class="ml-2" v-if="testsCount > 0">({{ test.pos }} {{ $t('of') }} {{ testsCount }})</span>
        </div>
      </div>

      <div class="col-12 order-10 text-center" v-if="showTestIntro && test">

        <h2 class="mt-7" v-if="test.test">{{ test.test }}</h2>
        <h2 class="mt-7" v-else>{{ $t('test') }} {{ $t('№') }}{{ test.pos }}</h2>
        <h1 class="mb-5 mt-2" v-if="test.description">«{{ test.description }}»</h1>
        <button
            class="btn btn-success btn-large btn-lg mb-9 btn-to-next-lesson"
            @click="startTest">
          <i class="ni ni-spaceship mr-2"></i>{{ $t('start_test') }} {{ $t('№') }}{{ test.pos }}
        </button>

      </div>

      <div class="col-12 order-10" v-if="!showTestIntro && test">

        <div class="row ml-xl-0 mr-xl-0 ml-3 mr-3 justify-content-center">

          <div class="col-xl-12 col-12 test-question-content text-center mt-xl-n4"
               v-if="currentTask.testtask">
                        <span v-if="currentTask.pos && !currentTask.testtask.startsWith($t('№')+currentTask.pos)"
                              class="mr-3">{{ $t('№') }}{{ currentTask.pos }}.</span>{{ currentTask.testtask }}
          </div>

          <div class="col-12 tab-video-notice-2 text-center pl-xl-0 pl-6 pr-xl-0 pr-6 mb-xl-4"
               v-if="test.description && test.description !== currentTask.testtask">{{
              test.description
            }}
          </div>

          <div class="col-12 mr-12">
            <div
                v-for="(child, i) in testelements"
                :key="child.idtestelement"
                class="row py-1 mr-12" :id="'question'+child.idtestelement"
            >
              <div class="col-4 d-flex justify-content-right">
                <div class="ml-auto mr-0" style="font-size: 20px;">
                  {{ child.word }}
                </div>
              </div>
              <div class="col-1 px-0 d-flex justify-content-center">
                <div class="mr-auto">
                  <div
                      @mousedown="(e) => pointClick(e, child)"
                      @touchstart="(e) => pointClick(e, child)"
                      @mouseup="(e) => pointClick(e, child)"
                      @touchend="(e) => pointClick(e, child)"
                      :id="'left-'+child.idtestelement"
                      :idtestelement="child.idtestelement"
                      class="align-self-center"
                      style="z-index: 1000;border-radius: 100%; width: 40px; height: 40px; background-color: blue;"
                  ></div>
                </div>
              </div>

              <div class="col-4 offset-2 d-flex justify-content-left">
                <div class="align-self-center mx-2">
                  <div
                      @mousedown="(e) => pointClick(e, testelementsDropZone[i])"
                      @touchstart="(e) => pointClick(e, testelementsDropZone[i])"
                      @mouseup="(e) => pointClick(e, testelementsDropZone[i])"
                      @touchend="(e) => pointClick(e, testelementsDropZone[i])"
                      :id="'right-'+child.idtestelement"
                      :idtestelement="testelementsDropZone[i].idtestelement"
                      class="my-auto"
                      style="z-index: 1000;border-radius: 100%; width: 40px; height: 40px; background-color: blue;"
                  ></div>
                </div>
                <div class="align-self-center" style="font-size: 20px;">
                  {{ testelementsDropZone[i].word2 }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center text-center no-gutters">
          <button
              v-if="testmode==1 && done"
              class="btn btn-info mt-1"
              @click="next"
          >
            {{ $t('accept_answer') }}
          </button>
        </div>
      </div>
    </div>
    <div class="row mb-4 mt-1 justify-content-center no-gutters" v-if="!showTestIntro && test">
      <button
          class="btn btn-info"
          @click="skip"
      >
        {{ $t('omit_task') }} &rarr;
      </button>
    </div>
  </div>

</template>

<style src="@/assets/poliglotiki/main.css">
</style>
<script>
import api from '@/utils/api'

export default {
  name: 'Test13',
  props: {
    idtest: {default: null},
    lesson: {type: Object, default: null},
    points: {default: null},
    testsCount: {default: null},
    showButtons: {type: Boolean, default: true},
    testmode: {default: 0},
  },
  data: () => ({
    test: {},
    testtasks: [],
    testelements: [],
    taskIdx: 0,
    audio: new Audio(),
    done: false,
    complete: false,
    errorCount: 0,

    testelementsDropZone: [],
    showTestIntro: true,

    errorChord: 'https://www.poliglotiki.ru/images/pol-mp3/error_chord.mp3',
    okChord: 'https://www.poliglotiki.ru/images/pol-mp3/ok.mp3',

    startCoord: null, //{x: 0, y: 0},
    currentLine: null,
  }),

  computed: {
    currentTask: function () {
      return (this.taskIdx < this.testtasks.length) ? this.testtasks[this.taskIdx] : {}
    },
  },

  watch: {
    taskIdx: function () {
      this.loadTask()
    },
  },

  async mounted() {
    document.onselectstart = new Function("return false");
    api({url: '/tests/' + this.idtest}).then(resp => {
      this.test = resp.data
    })
    const response = await api({url: '/testtasks?sort=pos' + (this.idtest ? '&filter[idtest]=' + this.idtest : '')})
    this.testtasks = response.data
    window.addEventListener('resize', () => {
      this.repaint()
    })
  },

  methods: {
    async startTest() {
      if (this.testtasks.length) {
        if (this.test.audio) {
          await this.play(this.test.audio)
        }
        this.showTestIntro = false
        this.loadTask()
      }
    },
    async loadTask() {
      if (this.currentTask.idtesttask) {
        const response = await api({
          method: 'get',
          url: '/testelements?filter[idtesttask]=' + this.currentTask.idtesttask
        })
        this.testelements = response.data

        this.testelementsDropZone = []
        for (let index = 0; index < this.testelements.length; index++) {
          this.testelementsDropZone.push({
            idtestelement: this.testelements[index].idtestelement,
            word2: this.testelements[index].word2,
            child: []
          })
        }

        this.testelements = this.shuffle(this.testelements)
        this.disconnectAllLines()
      } else {
        this.$emit('testComplete')
      }
    },

    getBy(propname, value, array) {
      for (let index = 0; index < array.length; index++) {
        if (array[index][propname] === value) return array[index]
      }

      return {}
    },

    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]]
      }
      return a
    },

    play: function (path) {
      return new Promise((resolve) => {
        if (path) {
          this.audio.src = path
          this.audio.play()
          this.audio.onended = function () {
            // console.log('Звук закончился')
            resolve()
          }

          this.audio.onerror = function () {
            console.log('Звук error')
            resolve()
          }
        } else {
          resolve()
        }
      })
    },

    skip: function () {
      this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: 'Пропущено'})
      this.taskIdx++
    },

    next: async function () {
      if (this.complete) this.$emit('correctAnswer')
      else this.$emit('wrongAnswer', {
        test: this.test.test,
        taskIdx: this.taskIdx,
        error: `Неправильно соединено элементов: ${this.errorCount}.`
      })
      this.taskIdx++
    },


    getLine(pointEl) {
      // если к элементу присоединена линия, то берем ее
      if (pointEl && pointEl.getAttribute('connectedLine')) return document.getElementById(pointEl.getAttribute('connectedLine'))

      // иначе берем первую свободную
      for (let i = 0; i < this.testelements.length; i++) {
        const line = document.getElementById('line-' + i)
        if (!line.getAttribute('startId')) return line
      }

      return null
    },

    disconnectLine(line) {
      const endDiv = document.getElementById(line.getAttribute('endId'))
      if (endDiv) {
        endDiv.style.backgroundColor = 'blue'
        endDiv.setAttribute('connectedLine', '')
        line.setAttribute('endId', '')
      }

      const startDiv = document.getElementById(line.getAttribute('startId'))
      if (startDiv) {
        startDiv.style.backgroundColor = 'blue'
        startDiv.setAttribute('connectedLine', '')
        line.setAttribute('startId', '')
      }

      line.style.height = 0
    },

    disconnectAllLines() {
      for (let i = 0; i < this.testelements.length; i++) {
        const line = document.getElementById('line-' + i)
        if (line) this.disconnectLine(line)
      }
    },

    pointClick(event, item) {
      if (this.currentLine) this.endClick(event)
      else this.startClick(event, item)
    },

    repaint() {
      for (let i = 0; i < this.testelements.length; i++) {
        const leftDiv = document.getElementById('left-' + this.testelements[i].idtestelement)
        if (leftDiv && leftDiv.getAttribute('connectedLine')) {
          const line = document.getElementById(leftDiv.getAttribute('connectedLine'))
          if (line) this.adjustLine(line)
        }
      }
    },

    startClick(event, item) {
      this.currentLine = this.getLine(event.srcElement)
      if (!this.currentLine) return

      this.disconnectLine(this.currentLine)

      this.currentLine.setAttribute('startId', event.srcElement.id)
      event.srcElement.setAttribute('connectedLine', this.currentLine.id)
      event.srcElement.style.backgroundColor = 'blue'
      this.currentLine.style.backgroundColor = 'blue'

      let baseCoords = this.getCoords(document.getElementById('baseFrame'));
      this.startCoord = {
        x: this.getX(event) - baseCoords.left,
        y: this.getY(event) - baseCoords.top
      }
      this.adjustLine(this.currentLine, event)
    },

    getX(event) {
      if (/touch/.test(event.type)) {
        if (event.targetTouches.length > 0) return event.targetTouches[0].pageX
        if (event.changedTouches.length > 0) return event.changedTouches[0].pageX
        if (event.touches.length > 0) return event.touches[0].pageX
      }
      if (event.pageX) return event.pageX
      return null
    },

    getClientX(event) {
      if (/touch/.test(event.type)) {
        if (event.targetTouches.length > 0) return event.targetTouches[0].clientX
        if (event.changedTouches.length > 0) return event.changedTouches[0].clientX
        if (event.touches.length > 0) return event.touches[0].clientX
      }
      if (event.pageX) return event.pageX
      return null
    },

    getY(event) {
      if (/touch/.test(event.type)) {
        if (event.targetTouches.length > 0) return event.targetTouches[0].pageY
        if (event.changedTouches.length > 0) return event.changedTouches[0].pageY
        if (event.touches.length > 0) return event.touches[0].pageY
      }
      if (event.pageY) return event.pageY
      return null
    },

    getClientY(event) {
      if (/touch/.test(event.type)) {
        if (event.targetTouches.length > 0) return event.targetTouches[0].clientY
        if (event.changedTouches.length > 0) return event.changedTouches[0].clientY
        if (event.touches.length > 0) return event.touches[0].clientY
      }
      if (event.pageY) return event.pageY
      return null
    },


    lineClick(event) {
      if (this.currentLine) return
      const line = event.srcElement
      this.disconnectLine(line)

      /* Старый вариант, когда при нажатии на линию она становилась текущей
      if (this.currentLine) return
      this.currentLine = event.srcElement
      this.currentLine.style.backgroundColor = 'blue'
      const startDiv = document.getElementById(this.currentLine.getAttribute('startId'))
      const idtestelement = startDiv.getAttribute('idtestelement')
      startDiv.style.backgroundColor = 'blue'
      const endDiv = document.getElementById(this.currentLine.getAttribute('endId'))
      if (endDiv) {
        endDiv.style.backgroundColor = 'blue'
        endDiv.setAttribute('connectedLine', '')
      }
      this.currentLine.setAttribute('endId', '')

      let coords = this.getCoords(startDiv);
      let baseCoords = this.getCoords(document.getElementById('baseFrame'));
      this.startCoord = {x: coords.left - baseCoords.left + 25, y: coords.top - baseCoords.top + 15}
      this.adjustLine(this.currentLine, event)
      */
    },

    async endClick(event) {
      if (!this.currentLine) return
      const endDiv = /touch/.test(event.type) ? document.elementFromPoint(this.getClientX(event), this.getClientY(event)) : event.srcElement
      if (endDiv) {
        const curLineStartId = this.currentLine.getAttribute('startId').substr(0, 3);
        const endDivStartId = endDiv.id.substr(0, 3);
        if ((curLineStartId !== 'lef' && curLineStartId !== 'rig') || (endDivStartId !== 'lef' && endDivStartId !== 'rig')) return
        if (curLineStartId === endDivStartId) return
        if (endDiv.getAttribute('connectedLine')) {
          this.disconnectLine(document.getElementById(endDiv.getAttribute('connectedLine')))
        }

        this.startCoord = null
        endDiv.setAttribute('connectedLine', this.currentLine.id)
        this.currentLine.setAttribute('endId', endDiv.id)
        const idtestelement = endDiv.getAttribute('idtestelement')
        const startDiv = document.getElementById(this.currentLine.getAttribute('startId'))
        if (!startDiv) return
        const idtestelementLine = startDiv.getAttribute('idtestelement')
        let item = this.getBy('idtestelement', parseInt(idtestelementLine), this.testelements)

        if (this.testmode == 1) {
          item.correct = (idtestelement === idtestelementLine)
        } else if (idtestelement === idtestelementLine) {
          item.correct = true
          this.currentLine.style.backgroundColor = 'green'
          endDiv.style.backgroundColor = 'green'
          startDiv.style.backgroundColor = 'green'
          if (item.audio) {
            this.play(item.audio)
          } else {
            this.play(this.okChord)
          }
        } else {
          this.currentLine.style.backgroundColor = 'red'
          endDiv.style.backgroundColor = 'red'
          startDiv.style.backgroundColor = 'red'
          item.correct = false
          this.play(this.errorChord)
        }

        // if(this.startCoord) return // если к этому моменту, пока игрался звук, уже начали заново таскать линию, то выходим
        this.currentLine = null

        this.errorCount = 0
        this.testelements.forEach(function (e) {
          if (e.correct !== true) this.errorCount++
        }, this)
        this.done = !this.getLine()
        this.complete = !this.errorCount
        if (this.testmode == 0 && this.complete) this.next()
      }
    },

    mousemove(event) {
      if (this.startCoord) {
        if (/touch/.test(event.type)) event.preventDefault();
        this.adjustLine(this.currentLine, event)
      }
    },

    cancelDrag() {
      if (this.startCoord) {
        this.disconnectLine(this.currentLine)
        this.startCoord = null
        this.currentLine = null
      }
    },

    // получаем координаты элемента в контексте документа
    getCoords(elem) {
      let box = elem.getBoundingClientRect();

      return {
        top: box.top + pageYOffset,
        left: box.left + pageXOffset
      };
    },


    adjustLine(line, mouse) {
      if (!line) return

      let baseCoords = this.getCoords(document.getElementById('baseFrame'));

      var fT, fL, tT, tL
      if (this.startCoord) {
        fT = this.startCoord.y
        fL = this.startCoord.x + 10
      } else {
        const startDiv = document.getElementById(line.getAttribute('startId'))
        if (!startDiv) return
        let startCoords = this.getCoords(startDiv);
        fT = startCoords.top - baseCoords.top + 20
        fL = startCoords.left - baseCoords.left + 20
      }

      if (mouse) {
        tT = this.getY(mouse) - baseCoords.top
        tL = this.getX(mouse) - baseCoords.left
      } else {
        const endDiv = document.getElementById(line.getAttribute('endId'))
        if (!endDiv) return
        let endCoords = this.getCoords(endDiv);
        tT = endCoords.top - baseCoords.top + 20
        tL = endCoords.left - baseCoords.left + 20
      }

      if (tL < fL) tL += 15

      var CA = Math.abs(tT - fT);
      var CO = Math.abs(tL - fL);
      var H = Math.sqrt(CA * CA + CO * CO);
      var ANG = 180 / Math.PI * Math.acos(CA / H);

      var top
      if (tT > fT) {
        top = (tT - fT) / 2 + fT;
      } else {
        top = (fT - tT) / 2 + tT;
      }
      var left
      if (tL > fL) {
        left = (tL - fL) / 2 + fL;
      } else {
        left = (fL - tL) / 2 + tL;
      }

      if ((fT < tT && fL < tL) || (tT < fT && tL < fL) || (fT > tT && fL > tL) || (tT > fT && tL > fL)) {
        ANG *= -1;
      }
      top -= H / 2;

      line.style["-webkit-transform"] = 'rotate(' + ANG + 'deg)';
      line.style["-moz-transform"] = 'rotate(' + ANG + 'deg)';
      line.style["-ms-transform"] = 'rotate(' + ANG + 'deg)';
      line.style["-o-transform"] = 'rotate(' + ANG + 'deg)';
      line.style["-transform"] = 'rotate(' + ANG + 'deg)';
      line.style.top = top + 'px';
      line.style.left = left + 'px';
      line.style.height = H + 'px';
    },


  },
}
</script>

<style scoped>

</style>
